module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/196.1c9ee06e.png";